<template>
  <table class="exchange-list" aria-describedby="exchange-list-desc">
    <tr>
      <th id="table_header_price">
        鱼干金额<br>（单位：鱼干）
      </th>
      <th id="table_header_benefit">
        鱼干购买分成<br>（单位：鱼干）
      </th>
      <th>
        官方平台分成<br>（单位：元宝）
      </th>
      <th>
        合作平台分成<br>（单位：元宝）
      </th>
    </tr>
    <tr>
      <td>390</td>
      <td>156</td>
      <td>16</td>
      <td>8</td>
    </tr>
    <tr>
      <td>360</td>
      <td>144</td>
      <td>14</td>
      <td>7</td>
    </tr>
    <tr>
      <td>320</td>
      <td>128</td>
      <td>13</td>
      <td>6</td>
    </tr>
    <tr>
      <td>290</td>
      <td>116</td>
      <td>12</td>
      <td>6</td>
    </tr>
    <tr>
      <td>240</td>
      <td>96</td>
      <td>10</td>
      <td>5</td>
    </tr>
    <tr>
      <td>200</td>
      <td>80</td>
      <td>8</td>
      <td>4</td>
    </tr>
    <tr>
      <td>180</td>
      <td>72</td>
      <td>7</td>
      <td>4</td>
    </tr>
    <tr>
      <td>160</td>
      <td>64</td>
      <td>6</td>
      <td>3</td>
    </tr>
    <tr>
      <td>140</td>
      <td>56</td>
      <td>6</td>
      <td>3</td>
    </tr>
    <tr>
      <td>110</td>
      <td>44</td>
      <td>4</td>
      <td>2</td>
    </tr>
    <tr>
      <td>90</td>
      <td>36</td>
      <td>4</td>
      <td>2</td>
    </tr>
    <tr>
      <td>60</td>
      <td>24</td>
      <td>2</td>
      <td>1</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'ExchangeList',
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style scoped lang="scss">
.exchange-list {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #d6d9e1;
  border-collapse: collapse;
  th,
  td {
    line-height: 26px;
    text-align: center;
    font-weight: 400;
    font-size: 12px;
    border: 1px solid #d6d9e1;
    color: #555462;
  }
}
</style>
